import React, { useRef, useState } from 'react';
import { Container, Form, Image, Modal, } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { addCampCaptainErrors } from '../../../constants/error.constants';
import LoadButton from '../../common/LoadButton';
import { SCHOOL_CHALLENGES } from '../../../constants/routes.constants';
import { ErrorMessage } from '@hookform/error-message';
import { schoolViewModel } from './school.view.model';
import customizeBannerUpload from '../../../assets/images/upload-ic.svg';
import ImageCropModal from '../../common/image-crop-rotate/ImageCropModal';
import { imageUtils } from '../../../utils/image.utils';
import closeIcon from '../../../assets/icon/icon-darker-close.svg';
import { checkEmailValidation } from '../../../utils/utils';

const AddCaptainModal = ({ show, closeModal, getCampCaptainsList, handleComplete }) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [profilePic, setProfilePic] = useState(null);
    const [uploadImage, setUploadImage] = useState(null);
    const [isDisabled, setIsDisable] = useState(false);
    const [imageCropPopup, setImageCropPopup] = useState(false);
    const [imageForCrop, setImageForCrop] = useState(null);
    const profileImage = useRef();
    const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
        mode: 'onBlur',
    });

    const onSubmit = handleSubmit(async (formData) => {
        setIsLoading(true);
        const params = getValues()
        let body = {
            first_name: params["first_name"],
            last_name: params["last_name"],
            email: params["email"]
        }
        if (!checkEmailValidation(params["email"])) {
            setError("email", {
                type: 'manual',
                message: addCampCaptainErrors.email.invalid,
            });
            return setIsLoading(false);
        }
        try {
            let res = await schoolViewModel.addCampCaptain(body)
            if (uploadImage) schoolViewModel.addCampCaptainMedia(res.id, uploadImage)
            setIsLoading(false);
            getCampCaptainsList();
            handleComplete(res?.id);
        } catch (error) {
            console.log(error)
            setIsLoading(false);
            setError("email", {
                type: 'manual',
                message: addCampCaptainErrors.email.exist,
            });
            setIsLoading(false);
        }
    })

    const handleProfileImageSelection = (e) => {
        const files = e.target.files;
        setIsDisable(true);
        if (files.length) {
            setImageForCrop(files[0])
            setImageCropPopup(true)
        }
    };

    const onCropComplete = (croppedImage) => {
        const imagePromise = imageUtils.getImagePromise(croppedImage);
        imagePromise
            .then((image) => {
                setProfilePic(image.preview);
                setUploadImage(image);
                setImageForCrop(null);
                setIsDisable(false);
            });
    }

    return (
        <Modal show={show} onHide={closeModal} className="account-varification lets-customize partner-side">
            <Modal.Header>
                <Modal.Title>
                    <h2 className='mt-40'>Add a Captain</h2>
                    <div className="close-button" data-dismiss="modal" onClick={closeModal}>
                        <img src={closeIcon} alt="Close" />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='partner-wrapper-main'>
                    <ImageCropModal
                        imageCropPopup={imageCropPopup}
                        setImageCropPopup={setImageCropPopup}
                        image={imageForCrop}
                        setImage={setImageForCrop}
                        setPicture={onCropComplete}
                        heading='Edit your profile image'
                    />

                    <Container>
                        <div className="d-flex justify-content-start captain-modal">
                            <div className="a-challenge-partner">
                                <Form className='mt-50 mb-40' onSubmit={onSubmit}>
                                    <Form.Group controlId="formFile" className="mb-3 upload-image">
                                        <div className='customize-user-img  partner-editimg'>
                                            <Image src={profilePic} alt="" />
                                            <span className='customize-banner-upload' onClick={() => profileImage.current.click()}><Image src={customizeBannerUpload} alt="" /></span>
                                            <input
                                                className="d-none"
                                                accept="image/png, image/jpeg, image/jpg, .heic, .HEIC"
                                                id='profile_picture'
                                                name='profile_picture'
                                                type="file"
                                                ref={profileImage}
                                                onChange={(e) => handleProfileImageSelection(e)}
                                            />
                                        </div>
                                    </Form.Group>
                                    <Form.Row>
                                        <Form.Group className="mb-3" controlId="">
                                            <FormLabel>Captain's First name</FormLabel>
                                            <FormInput
                                                name="first_name"
                                                className="form-input"
                                                data-testid="first_name"
                                                ref={register({
                                                    required:
                                                        addCampCaptainErrors.first_name.required,
                                                })}
                                                placeholder="Enter first name"
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="first_name"
                                                className="small text-danger"
                                                as="label"
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="">
                                            <FormLabel>Captain's Last name</FormLabel>
                                            <FormInput
                                                name="last_name"
                                                className="form-input"
                                                data-testid="last_name"
                                                ref={register({
                                                    required:
                                                        addCampCaptainErrors.last_name.required,
                                                })}
                                                placeholder="Enter last name"
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="last_name"
                                                className="small text-danger"
                                                as="label"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Group className="mb-3" controlId="">
                                        <FormLabel>Email</FormLabel>
                                        <FormInput
                                            name="email"
                                            className="form-input"
                                            data-testid="email"
                                            ref={register({
                                                required:
                                                    addCampCaptainErrors.email.required,
                                            })}
                                            placeholder="Enter email"
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="email"
                                            className="small text-danger"
                                            as="label"
                                        />
                                    </Form.Group>
                                    <Form.Group className="container-fluid">
                                        <LoadButton
                                            className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                                            text="Create captain"
                                            isLoading={isLoading}
                                            testid="submit"
                                        />
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </Container>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default AddCaptainModal;